import React, { useEffect } from "react";
import MarkedDownContent from "../../../organisms/MarkedDownContent";
import {
  ModalPageCopy,
  ModalPageHeading,
  ModalPageWrapper,
  ModalPageBody,
  ModalPageFooter,
  ModalPageSvg,
} from "../../../organisms/ModalPage";
import { Helmet } from "react-helmet";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import "./IneligibleScreen.scss";

interface Props {
  title: string;
  heading: string;
  bodyText: string;
  buttonText: string;
  children: any;
  onClick: () => void;
  hasContactUs: boolean;
}

export const IneligibleScreen: React.FC<Props> = ({
  title,
  heading,
  bodyText,
  buttonText = "Contact Us",
  children,
  onClick = () => {
    window.location.href = "mailto:support@gloji.co.uk";
  },
  hasContactUs = false,
}: Props) => {
  useEffect(() => {
    if (title) {
      window.gtag("event", "page_view", {
        page_title: `${title}`,
      });
    }
  }, [title]);

  return (
    <div className="ineligible-screen">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ModalPageWrapper>
        <ModalPageBody>
          {children && <ModalPageSvg>{children}</ModalPageSvg>}
          <ModalPageHeading>{heading}</ModalPageHeading>
          <ModalPageCopy>
            <MarkedDownContent content={bodyText} />
          </ModalPageCopy>
        </ModalPageBody>
        {hasContactUs && (
          <ModalPageFooter>
            <Button label={buttonText} variant="contained" color="primary" onClick={onClick}>
              {buttonText}
            </Button>
          </ModalPageFooter>
        )}
      </ModalPageWrapper>
    </div>
  );
};
